"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.availableDrillTargetsValidation = void 0;
var general_1 = require("../../../events/general");
function availableDrillTargetsValidation(availableDrillTargets, enableKPIDashboardDrillFromAttribute, ctx, cmd) {
    var items = availableDrillTargets;
    var attributeItems = items === null || items === void 0 ? void 0 : items.attributes;
    // Validate availableDrillTargets when enableKPIDashboardDrillFromAttribute FF false, we reject availableDrillTargets attributes to save.
    if (!enableKPIDashboardDrillFromAttribute && attributeItems && attributeItems.length > 0) {
        throw general_1.invalidArgumentsProvided(ctx, cmd, "Attributes in availableDrillTargets are not supported when enableKPIDashboardDrillFromAttribute FF is set to false");
    }
    return items;
}
exports.availableDrillTargetsValidation = availableDrillTargetsValidation;
//# sourceMappingURL=availableDrillTargetsValidation.js.map